import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole);

import "amfe-flexible"
import Vant from 'vant'
import 'vant/lib/index.css'

import "@/styles/index.less"
import "@/styles/publicPage.less"
// videojs
import videojs from "video.js";
import "video.js/dist/video-js.css";
import 'videojs-contrib-hls' // 用来播放hls流
import '@videojs/http-streaming'
Vue.prototype.$video = videojs;

// 引入事件总线
Vue.prototype.$EventBus = new Vue();


//引入过滤器
import filters from "./filter"
Vue.use(filters);
Vue.use(Vant)


import {
  Lazyload
} from 'vant';

Vue.use(Lazyload);
Vue.config.productionTip = false

new Vue({
  router,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')